export { default, getServerSideProps } from "pages/dispensary-info/[slug]/menu";
